import { getCountryFlag } from '../utilities/get-country-flag';
/**
 * Jabra ecom domains
 * @remarks This configuration should be somewhere in API.
 */
export var jabraEcomDomains = [
    {
        code: "AU" /* EcomCountryCode.Australia */,
        url: "https://www.jabra.com/en-au/" /* JabraEcomCountryUrl.Australia */,
        name: "Australia" /* EcomCountryName.Australia */,
        flag: getCountryFlag("AU" /* EcomCountryCode.Australia */),
    },
    {
        code: "AT" /* EcomCountryCode.Austria */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Austria" /* EcomCountryName.Austria */,
        flag: getCountryFlag("AT" /* EcomCountryCode.Austria */),
    },
    {
        code: "BE" /* EcomCountryCode.Belgium */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Belgium" /* EcomCountryName.Belgium */,
        flag: getCountryFlag("BE" /* EcomCountryCode.Belgium */),
    },
    {
        code: "BG" /* EcomCountryCode.Bulgaria */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Bulgaria" /* EcomCountryName.Bulgaria */,
        flag: getCountryFlag("BG" /* EcomCountryCode.Bulgaria */),
    },
    {
        code: "CA" /* EcomCountryCode.Canada */,
        url: "https://www.jabra.com/en-ca/" /* JabraEcomCountryUrl.Canada */,
        name: "Canada" /* EcomCountryName.Canada */,
        flag: getCountryFlag("CA" /* EcomCountryCode.Canada */),
    },
    {
        code: "CN" /* EcomCountryCode.China */,
        url: "https://www.jabra.cn" /* JabraEcomCountryUrl.China */,
        name: "China" /* EcomCountryName.China */,
        flag: getCountryFlag("CN" /* EcomCountryCode.China */),
    },
    {
        code: "HR" /* EcomCountryCode.Croatia */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Croatia" /* EcomCountryName.Croatia */,
        flag: getCountryFlag("HR" /* EcomCountryCode.Croatia */),
    },
    {
        code: "CY" /* EcomCountryCode.Cyprus */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Cyprus" /* EcomCountryName.Cyprus */,
        flag: getCountryFlag("CY" /* EcomCountryCode.Cyprus */),
    },
    {
        code: "CZ" /* EcomCountryCode.CzechRepublic */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Czech Republic" /* EcomCountryName.CzechRepublic */,
        flag: getCountryFlag("CZ" /* EcomCountryCode.CzechRepublic */),
    },
    {
        code: "DK" /* EcomCountryCode.Denmark */,
        url: "https://www.jabra.com/da-dk/" /* JabraEcomCountryUrl.Denmark */,
        name: "Denmark" /* EcomCountryName.Denmark */,
        flag: getCountryFlag("DK" /* EcomCountryCode.Denmark */),
    },
    {
        code: "EE" /* EcomCountryCode.Estonia */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Estonia" /* EcomCountryName.Estonia */,
        flag: getCountryFlag("EE" /* EcomCountryCode.Estonia */),
    },
    {
        code: "FI" /* EcomCountryCode.Finland */,
        url: "https://www.jabra.com/fi-fi/" /* JabraEcomCountryUrl.Finland */,
        name: "Finland" /* EcomCountryName.Finland */,
        flag: getCountryFlag("FI" /* EcomCountryCode.Finland */),
    },
    {
        code: "FR" /* EcomCountryCode.France */,
        url: "https://www.jabra.com/fr-fr/" /* JabraEcomCountryUrl.France */,
        name: "France" /* EcomCountryName.France */,
        flag: getCountryFlag("FR" /* EcomCountryCode.France */),
    },
    {
        code: "DE" /* EcomCountryCode.Germany */,
        url: "https://www.jabra.com/de-de/" /* JabraEcomCountryUrl.Germany */,
        name: "Germany" /* EcomCountryName.Germany */,
        flag: getCountryFlag("DE" /* EcomCountryCode.Germany */),
    },
    {
        code: "GB" /* EcomCountryCode.GreatBritain */,
        url: "https://www.jabra.com/en-gb/" /* JabraEcomCountryUrl.GreatBritain */,
        name: "Great Britain" /* EcomCountryName.GreatBritain */,
        flag: getCountryFlag("GB" /* EcomCountryCode.GreatBritain */)
    },
    {
        code: "GR" /* EcomCountryCode.Greece */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Greece" /* EcomCountryName.Greece */,
        flag: getCountryFlag("GR" /* EcomCountryCode.Greece */),
    },
    {
        code: "HK" /* EcomCountryCode.HongKong */,
        url: "https://www.jabra.com/en-hk/" /* JabraEcomCountryUrl.HongKong */,
        name: "India" /* EcomCountryName.India */,
        flag: getCountryFlag("HK" /* EcomCountryCode.HongKong */),
    },
    {
        code: "HU" /* EcomCountryCode.Hungary */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Hungary" /* EcomCountryName.Hungary */,
        flag: getCountryFlag("HU" /* EcomCountryCode.Hungary */),
    },
    {
        code: "IN" /* EcomCountryCode.India */,
        url: "https://www.jabra.com/en-in/" /* JabraEcomCountryUrl.India */,
        name: "India" /* EcomCountryName.India */,
        flag: getCountryFlag("IN" /* EcomCountryCode.India */),
    },
    {
        code: "IE" /* EcomCountryCode.Ireland */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Ireland" /* EcomCountryName.Ireland */,
        flag: getCountryFlag("IE" /* EcomCountryCode.Ireland */),
    },
    {
        code: "IT" /* EcomCountryCode.Italy */,
        url: "https://www.jabra.com/it-it/" /* JabraEcomCountryUrl.Italy */,
        name: "Italy" /* EcomCountryName.Italy */,
        flag: getCountryFlag("IT" /* EcomCountryCode.Italy */),
    },
    {
        code: "JP" /* EcomCountryCode.Japan */,
        url: "https://www.jabra.com/ja-jp/" /* JabraEcomCountryUrl.Japan */,
        name: "Japan" /* EcomCountryName.Japan */,
        flag: getCountryFlag("JP" /* EcomCountryCode.Japan */),
    },
    {
        code: "LV" /* EcomCountryCode.Latvia */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Latvia" /* EcomCountryName.Latvia */,
        flag: getCountryFlag("LV" /* EcomCountryCode.Latvia */),
    },
    {
        code: "LT" /* EcomCountryCode.Lithuania */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Lithuania" /* EcomCountryName.Lithuania */,
        flag: getCountryFlag("LT" /* EcomCountryCode.Lithuania */),
    },
    {
        code: "LU" /* EcomCountryCode.Luxembourg */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Luxembourg" /* EcomCountryName.Luxembourg */,
        flag: getCountryFlag("LU" /* EcomCountryCode.Luxembourg */),
    },
    {
        code: "MT" /* EcomCountryCode.Malta */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Malta" /* EcomCountryName.Malta */,
        flag: getCountryFlag("MT" /* EcomCountryCode.Malta */),
    },
    {
        code: "NL" /* EcomCountryCode.Netherlands */,
        url: "https://www.jabra.com/nl-nl/" /* JabraEcomCountryUrl.Netherlands */,
        name: "Netherlands" /* EcomCountryName.Netherlands */,
        flag: getCountryFlag("NL" /* EcomCountryCode.Netherlands */),
    },
    {
        code: "NZ" /* EcomCountryCode.NewZealand */,
        url: "https://www.jabra.com/en-nz/" /* JabraEcomCountryUrl.NewZealand */,
        name: "New Zealand" /* EcomCountryName.NewZealand */,
        flag: getCountryFlag("NZ" /* EcomCountryCode.NewZealand */),
    },
    {
        code: "NO" /* EcomCountryCode.Norway */,
        url: "https://www.jabra.com/nb-no/" /* JabraEcomCountryUrl.Norway */,
        name: "Norway" /* EcomCountryName.Norway */,
        flag: getCountryFlag("NO" /* EcomCountryCode.Norway */),
    },
    {
        code: "PL" /* EcomCountryCode.Poland */,
        url: "https://www.jabra.com/pl-pl/" /* JabraEcomCountryUrl.Poland */,
        name: "Poland" /* EcomCountryName.Poland */,
        flag: getCountryFlag("PL" /* EcomCountryCode.Poland */),
    },
    {
        code: "PT" /* EcomCountryCode.Portugal */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Portugal" /* EcomCountryName.Portugal */,
        flag: getCountryFlag("PT" /* EcomCountryCode.Portugal */),
    },
    {
        code: "RO" /* EcomCountryCode.Romania */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Romania" /* EcomCountryName.Romania */,
        flag: getCountryFlag("RO" /* EcomCountryCode.Romania */),
    },
    {
        code: "SG" /* EcomCountryCode.Singapore */,
        url: "https://www.jabra.com/en-sg/" /* JabraEcomCountryUrl.Singapore */,
        name: "Singapore" /* EcomCountryName.Singapore */,
        flag: getCountryFlag("SG" /* EcomCountryCode.Singapore */),
    },
    {
        code: "SK" /* EcomCountryCode.Slovakia */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Slovakia" /* EcomCountryName.Slovakia */,
        flag: getCountryFlag("SK" /* EcomCountryCode.Slovakia */),
    },
    {
        code: "SI" /* EcomCountryCode.Slovenia */,
        url: "https://www.jabra.com/en-emea/" /* JabraEcomCountryUrl.Emea */,
        name: "Slovenia" /* EcomCountryName.Slovenia */,
        flag: getCountryFlag("SI" /* EcomCountryCode.Slovenia */),
    },
    {
        code: "ES" /* EcomCountryCode.Spain */,
        url: "https://www.jabra.com/es-es/" /* JabraEcomCountryUrl.Spain */,
        name: "Spain" /* EcomCountryName.Spain */,
        flag: getCountryFlag("ES" /* EcomCountryCode.Spain */),
    },
    {
        code: "SE" /* EcomCountryCode.Sweden */,
        url: "https://www.jabra.com/sv-se/" /* JabraEcomCountryUrl.Sweden */,
        name: "Sweden" /* EcomCountryName.Sweden */,
        flag: getCountryFlag("SE" /* EcomCountryCode.Sweden */),
    },
    {
        code: "CH" /* EcomCountryCode.Switzerland */,
        url: "https://www.jabra.com/de-ch/" /* JabraEcomCountryUrl.Switzerland */,
        name: "Switzerland" /* EcomCountryName.Switzerland */,
        flag: getCountryFlag("CH" /* EcomCountryCode.Switzerland */),
    },
];
